'use client';

import { Link } from '@/i18n/navigation';
import Image from 'next/image';
import type React from 'react';
import { IconArrowUpRight } from '../../../components/ui/icons';

type LocalizedHref = React.ComponentProps<typeof Link>['href'];

interface CategoryCardProps {
    name: string;
    imageSrc: string;
    className?: string;
    href: LocalizedHref;
}

export default function CategoryCard({ name, imageSrc, className, href }: CategoryCardProps) {
    const _initialClassName = `
        block
        rounded-[16px]
        group
        cursor-pointer
        relative
        h-[80px]
        md:h-[129px]
        md:w-full
        bg-cover bg-center bg-no-repeat
        bg-[url(/images/categories/category-gradient.svg)]
        hover:bg-[url(/images/categories/category-gradient-hover.svg)]
        transition-[background-image]
    `;

    return (
        <Link className={(className ? `${className} ` : '') + _initialClassName} href={href} prefetch={false}>
            <Image
                className="absolute top-[50%] left-0 translate-y-[-50%]"
                src={`/images/categories/${imageSrc}.svg`}
                height={86}
                width={60}
                alt={name}
            />
            <h4
                className="
          relative
          w-full
          md:absolute
          px-3
          top-[50%]
          left-0
          translate-y-[-50%]
          z-1
          font-bold
          md:text-lg
          text-[13px]
          text-center
          md:leading-none
          leading-[1rem]
        "
            >
                {name}
            </h4>
            <IconArrowUpRight
                className="
          absolute z-1
          md:right-[15px] md:bottom-[15px]
          right-[5px] bottom-[5px]
          group-hover:bottom-[20px]
          transition-[bottom]"
            />
        </Link>
    );
}
